import { any, both, compose, curry, equals, filter, hasPath, inc, isEmpty, join, lensPath, lensProp, match, notEmpty, nth, pipe, pipe_, propOr, sliceTo, toInteger, typeOf, values, view } from '~/utils/lib/core/prelude'

export const hasMessageEventData = curry((
  /** @type {MessageEvent} */ event,
  /** @type {string} */ data
  ) => pipe_(
    event,
    propOr('', 'data'),
    equals(data)
  )
)
/**
 * @function hasRouteOptions
 * @desc
 *    - Seems like a opaque code, but it is actually the only way to get
 *      the Nuxt Page Component options
 *    - See for instance "nuxt-auth-module" `routeOption()` algorithm [1]
 * @example
 *    const has = hasRouteOption(route, 'auth', 'guest')
 * @link https://github.com/nuxt-community/auth-module/blob/dev/src/utils/index.ts#L49-L69 [1]
 * @param {import('vue-router').RouteLocationNormalizedGeneric} route
 * @param {string} key
 * @param {any} value
 * @returns {boolean}
 */
export function hasRouteOption(route, key, value) {
  const get_matched       = view( lensProp('matched') )
  const get_components    = view( lensProp('components') )
  const path_options_key  = [ 'options', key ]
  const get_options_key   = view( lensPath(path_options_key))

  return pipe_(
    route,
    get_matched,
    any(
      pipe(
        get_components,
        // @ts-expect-error
        values,
        any(
          both(
            hasPath(path_options_key),
            compose(
              equals(value),
              get_options_key
            )
          )
        )
      ),
    )
  )
}
/**
 * @function addCopyNumber
 * @example
 *    addCopyNumber('Hello')    // "Hello (1)"
 *    addCopyNumber('Foo (5)')  // "Foo (6)"
 * @param {string} str
 * @return {string}
 */
export function addCopyNumber(str) {
  const matchSuffix = match(/ \((\d+)\)$/, str)

  switch (isEmpty(matchSuffix)) {

    case true:
      return `${str} (1)`

    case false: {
      const base = sliceTo(
        /// @XXX "ramda-adjunct" `match` typing returns an `string[]`, however it
        ///      contains more properties such as `index`
        // @ts-ignore: "ramda-adjunct" wrong typing
        matchSuffix.index,
        str
      )
      const idx = compose(inc, toInteger, nth(1))(matchSuffix)

      return `${base} (${idx})`
    }
  }
}
/**
 * @desc From Vue ":class" to string
 * @param {import('~/utils/lib/core/types_').ElementClass|undefined} source
 * @returns {string}
 */
export const elementClassToString = source => {
  switch (typeOf(source)) {

    case 'object':
      return pipe_(
        source,
        // @ts-expect-error: TypeScript guard limitation
        filter( notEmpty ),
        join(' '),
      )

    case 'array':
      // @ts-expect-error: TypeScript guard limitation
      return join(' ', /** @type {string[]} */ source)

    case 'string':
      // @ts-expect-error: TypeScript guard limitation
      return source

    default:
      return ''
  }
}

